import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { GroupLedger } from "projects/sepidz-web-framework/src/lib/models";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "ngx-groupledger-form",
  templateUrl: "./groupledger-form.component.html",
  styleUrls: ["./groupledger-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupLedgerFormComponent extends BaseFormComponent<GroupLedger> {
  private selectedGroupLedgerCodeLen: number;
  isOk4Load: boolean = false;
  constructor(private missetup: MisSetupService, protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.missetup.getall();
  }
  async ngOnInit() {
    this.apiName = "GroupLedger";
    this.label = this.translate("ClientApp.BackOffice.ACC.GroupLedger.GroupLedger");
    this.setlen();
    super.ngOnInit();
  }
  setMaxCode() {
    if (this.missetup.getnumber("ACC", "PLLEN") === 0)
      this.sts.showDialog(
        this.translate("ClientApp.BackOffice.ACC.GroupLedger.SettingNotComplete"),
        this.translate("ClientApp.BackOffice.ACC.GroupLedger.ErrorSetting")
      );

    if (!this.model.Code || this.model.Code <= 0) {
      this.httpCommonService
        .getMaxCode(this.apiName)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((data) => {
          if (!this.model) this.model = <GroupLedger>{};
          if (data) {
            this.model["Code"] = data as number;
            this.setFormGroup(this.model);
          }
        });
    }
    if (this.columns && this.columns.length > 0) {
      var item = this.columns.filter(function (item) {
        return item.name === "Code";
      })[0];
      if (item) {
        item.maxLength = this.missetup.getnumber("ACC", "PLLEN");
        item.minLength = 1;
      }
    }
  }
  setlen() {
    this.selectedGroupLedgerCodeLen = this.missetup.getnumber("ACC", "PLLEN");
    if (this.selectedGroupLedgerCodeLen === 0)
      this.sts.showDialog(
        this.translate("ClientApp.BackOffice.ACC.GroupLedger.SettingNotComplete"),
        this.translate("ClientApp.BackOffice.ACC.GroupLedger.ErrorSetting")
      );
  }

  setColumnAttribute() {
    let minformat = [1, 10, 100, 1000, 10000, 100000];
    let maxformat = [9, 99, 999, 9999, 99999, 999999];
    this.orignalColumns.forEach((x) => {
      if (x.name === "GroupLedgerId") x.disabled = !this.isNewRow;
      if (x.name === "Code") {
        x.min = minformat[this.selectedGroupLedgerCodeLen - 1];
        x.max = maxformat[this.selectedGroupLedgerCodeLen - 1];
      }
    });
  }
  isValid() {
    if (!this.selectedGroupLedgerCodeLen || this.selectedGroupLedgerCodeLen <= 0) this.setlen();
    let result =
      this.formGroup.controls["Code"] &&
      this.formGroup.controls["Code"].value &&
      this.formGroup.controls["Code"].value.toString().length === this.selectedGroupLedgerCodeLen;
    if (!result)
      this.formGroup.controls["Code"].setErrors({ customerror: `${this.translate("ClientApp.BackOffice.ACC.GeneralLedger.GroupLedgerWrong")}` });
    return result;
  }
  addControl() {
    this.isOk4Load = false;
    this.isOk4Load = true;
    this.cd.markForCheck();
  }
}
